module.exports = __webpack_public_path__ + "static/media/combo-thit-trung-cha.2d98ddcb.jpg";